// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 726 ? "Curriculum" : chunkId) + "." + {"128":"73cf57f9","726":"c5d82109"}[chunkId] + ".chunk.css";
};